import { NE_PRINT_LABEL_SOURCE } from '../../constants';

export function getQueryParams(searchParams: URLSearchParams): {
  ids: string[];
  source: string;
  orderId: string;
} {
  const idsParam = searchParams.get('ids');
  const source =
    searchParams.get('source') || NE_PRINT_LABEL_SOURCE.ORDERS_LIST;
  const orderId = searchParams.get('orderId') || '';

  return { ids: idsParam ? idsParam.split(',') : [], source, orderId };
}
